import {Component, Input} from '@angular/core';
import {
  ProjectMappingItemRef,
  ProjectMappingJoinReason,
  ProjectMappingVocabulary
} from '../../../../model/ProjectMapping';

/**
 * Renders ONE `joinReason` as a sentence a customer can act on.
 *
 * The server sends codes and never prose, because its English would not
 * survive 21 locales (`ProjectMappingReview.md` section 6). The wording
 * therefore lives here, as `i18n` spans in an `ngSwitch`, rather than behind a
 * `LanguagePipe.get()` lookup: an `ngSwitch` is extracted by `ng extract-i18n`
 * into the `.xtb` bundles automatically, whereas the runtime map is scraped
 * from hidden spans in `app.component.html` and silently yields the raw id for
 * anything nobody remembered to add there.
 *
 * `joinedTo` names the specific sibling matched, so the sentence is
 * *"shares its interior PDF with The Quiet Garden"* rather than one opaque
 * reason for the whole cluster. That per-member specificity is the
 * transparency requirement this surface exists to satisfy.
 */
@Component({
  selector: 'app-project-mapping-reason',
  templateUrl: './project-mapping-reason.component.html',
  styleUrls: ['./project-mapping-reason.component.css']
})
export class ProjectMappingReasonComponent {

  @Input() reason: ProjectMappingJoinReason;
  @Input() joinedTo: ProjectMappingItemRef | null = null;
  /** Display name of `joinedTo`, resolved by the parent from its caches. */
  @Input() joinedToLabel = '';

  get corroborationOnly(): boolean {
    return ProjectMappingVocabulary.isCorroborationOnly(this.reason);
  }

  /** True when there is a named sibling to point at. */
  get hasTarget(): boolean {
    return !!this.joinedTo && !!this.joinedToLabel;
  }
}
